module.exports = __webpack_public_path__ + "img/20200320.59dbe733.png";